export const tableData = [
    {
        key: "label-position",
        type: "props",
        parameterType: "String",
        desc: "标签的位置",
        remark: "left/right/top/bottom 默认right",
    },
    {
        key: "action",
        type: "props",
        parameterType: "String",
        desc: "上传地址",
        remark: "",
    },
    {
        key: "isBatchDelete",
        type: "props",
        parameterType: "Boolean",
        desc: "是否启用批量删除",
        remark: "",
    },
    {
        key: "rules",
        type: "props",
        parameterType: "Array",
        desc: "规则",
        remark: "add 添加|import 导入|export 导出|export-all 导出全部 |export-current 导出本页|export-select 导出选中|delete 删除全部",
    },
    {
        key: "changeFile",
        type: "methods",
        parameterType: "",
        desc: "文件改变时触发",
        remark: "可用于 用户自行处理文件上传",
    },
    {
        key: "btnClick",
        type: "methods",
        parameterType: "",
        desc: "按钮公共点击方法 返回按钮的key值",
        remark: "add | export | exportSelect | exportAll | exportCurrent | batchDelete",
    },
    {
        key: "@add",
        type: "methods",
        parameterType: "",
        desc: "添加事件",
        remark: "",
    },
    {
        key: "@export",
        type: "methods",
        parameterType: "",
        desc: "导出",
        remark: "",
    },
    {
        key: "@exportSelect",
        type: "methods",
        parameterType: "",
        desc: "导出选中",
        remark: "",
    },
    {
        key: "@exportAll",
        type: "methods",
        parameterType: "",
        desc: "导出全部",
        remark: "",
    },
    {
        key: "@exportCurrent",
        type: "methods",
        parameterType: "",
        desc: "导出当前页",
        remark: "",
    },
    {
        key: "@batchDelete",
        type: "methods",
        parameterType: "",
        desc: "删除全部",
        remark: "",
    }
]
